// The reset email's link is /password-code?email=…&code=…, built by the Cognito
// custom-message Lambda (api.git, src/cognito/custom-message.ts) with the email
// URI-encoded and the code as Cognito gives it.
//
// Parsed by hand rather than with URLSearchParams, which reads '+' as a space: a
// mail client or link scanner that unescapes the email's %2B would otherwise turn
// person+halo@example.com into an address with a space in it. A value that is not
// valid percent-encoding is kept as it is.
export function readResetLink(search) {
  const params = {};
  for (const pair of search.replace(/^\?/, '').split('&')) {
    if (pair) {
      const [key, ...value] = pair.split('=');
      params[key] = decode(value.join('='));
    }
  }
  return { email: params.email ?? '', code: params.code ?? '' };
}

function decode(value) {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}

// The same reset in the app. The path names a navigator long gone, because links
// already sent use it, and the app still routes it to its own
// ForgotPasswordCodeEntry, which asks for the code when this one is empty.
export function appResetLink(email, code) {
  return `haloapp://AuthNav/ForgotPasswordCodeEntry?email=${encodeURIComponent(
    email,
  )}&code=${encodeURIComponent(code)}`;
}

// Whether this browser is on a phone or tablet, where the Halo app can be
// installed to take appResetLink; a desktop browser has no app to hand it to.
// iPadOS Safari presents itself as a Mac, so a "Mac" with a touch screen counts.
export function canOpenApp(nav = globalThis.navigator) {
  const userAgent = nav?.userAgent ?? '';
  return (
    /Android|iPhone|iPad|iPod/i.test(userAgent) ||
    (/Macintosh/.test(userAgent) && nav.maxTouchPoints > 1)
  );
}
